<template>
    <div class="header" v-bind:style="{ backgroundColor: backgroundColor }">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div>

        <!-- <div class="logo" v-if="userData.city.city_code=='CITY648A62135012159'">
            平安后台管理系统 <span>— {{ city_mode }}</span>
        </div>
        <div class="logo" v-else-if="userData.city.city_code=='CITY626B83D0A3DE235'">
            领皓后台管理系统 <span>— {{ city_mode }}</span>
        </div>
        <div class="logo" v-else>
            耿师傅后台管理系统 <span>— {{ city_mode }}</span>
        </div> -->

        <div class="logo">
            {{ titleName }}后台管理系统 <span>— {{ city_mode }}</span>
        </div>

        <div class="header-right">
            <div class="header-user-con">
                <!-- 播报配置 -->
                <div class="public-screen" @click="broadcast">
                    <el-tooltip effect="dark" :content="`播报配置`" placement="bottom">
                        <i class="iconfont icon-weibiaoti--"></i>
                    </el-tooltip>
                </div>

                <!-- 网站地图按钮 -->
                <!-- <div class="public-screen" @click="webMap_isShow=!webMap_isShow">
                    <el-tooltip effect="dark" :content="`网站地图`" placement="bottom">
                        <i class="el-icon-menu"></i>
                    </el-tooltip>
                </div> -->

                <!-- 公屏组件按钮 -->
                <div class="public-screen" @click="homeDialog_isShow = !homeDialog_isShow">
                    <el-tooltip effect="dark" :content="`公屏`" placement="bottom">
                        <i class="el-icon-monitor"></i>
                    </el-tooltip>
                </div>

                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{ userData.name ? userData.name : name }}
                        <i class="el-icon-caret-bottom"></i>
                    </span>

                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <!-- 跑腿订单 -->
                <!--        <div class="legwork-box" style="margin-left: 20px">-->

                <!--          <el-button-->
                <!--                  class="add-order"-->

                <!--                  @click="toLegwork"-->
                <!--                  style="font-size: 18px; background-color:#409EFF;border-color: #409EFF;color: #fff"-->
                <!--          >-->
                <!--            <i class="el-icon-plus"></i>跑腿订单-->
                <!--          </el-button>-->

                <!--        </div>-->

                <!-- 代驾订单 -->
                <div class="scheduling-dispatch">
                    <el-button
                        class="add-order"
                        @click="dispatchBtn"
                        style="font-size: 18px; background-color: #f7ac35; border-color: #f7ac35; color: #fff"
                    >
                        <i class="el-icon-plus"></i>代驾订单
                    </el-button>
                </div>
            </div>
        </div>

        <!-- 公屏组件 -->
        <homeDialog :isShow="homeDialog_isShow"></homeDialog>

        <!-- 网站地图组件 -->
        <webMap :isShow="webMap_isShow"></webMap>

        <!-- 播报配置组件 -->
        <broadcastModel :isShow="broadcast_show"></broadcastModel>
    </div>
</template>
<script>
import bus from '../common/bus';
import homeDialog from './homeDialog.vue';
import webMap from './webMap.vue';
import broadcastModel from './broadcastModel.vue';
// import { resetRouter } from '../../router/index';
import { logout } from '../../utils/common'; //引入公共类模块的踢人
var _this;
export default {
    props: ['showAll'],
    components: {
        homeDialog,
        webMap,
        broadcastModel
    },
    data() {
        return {
            backgroundColor: '#fe6114',
            titleStr: '',
            titleName: '',
            userData: JSON.parse(localStorage.getItem('login')),
            collapse: false,
            fullscreen: false,
            name: 'jiuzhou',
            message: 2,
            // 公屏组件组件开关
            homeDialog_isShow: false,
            // 网站地图组件开关
            webMap_isShow: false,

            //播报配置开关
            broadcast_show: false,

            city_mode: ''
        };
    },

    created() {
        _this = this;

        _this.city_mode = _this.userData.city.name;

        _this.titleStr = JSON.parse(localStorage.getItem('cityInfo')).city_tag;
        _this.titleName = JSON.parse(localStorage.getItem('cityInfo')).name;
        if (_this.titleStr == 'HAIKOU') {
            // 小琳代驾
            _this.backgroundColor = '#1BA1FF';
        }
    },
    methods: {
        broadcast() {
            this.broadcast_show = !this.broadcast_show;
        },
        //跑腿订单
        toLegwork() {
            // 路由传参
            let routeData = this.$router.resolve({
                path: '/legwork'
            });
            window.open(routeData.href, '_blank');
        },

        // 代驾订单
        dispatchBtn() {
            // 路由传参
            let routeData = this.$router.resolve({
                path: '/substituteDrivingDispatch'
            });
            window.open(routeData.href, '_blank');
        },
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {
                // resetRouter()

                // 请求登出接口
                this.$post('/welcome/logoutsubmit')
                    .then((res) => {
                        bus.$emit('firstlog', false);

                        localStorage.removeItem('access_token');
                        sessionStorage.removeItem('navBar');
                        sessionStorage.removeItem('time_difference');
                        localStorage.removeItem('login');
                        localStorage.removeItem('city_tag');
                        this.$message.success(res.msg);

                        this.$nextTick(function () {
                            // 返回登录页面
                            // this.$router.push('/login');
                            if (localStorage.getItem('source') == 'gengshifu') {
                                this.$router.push('/login');
                            } else {
                                this.$router.push({ path: '/login', query: { source: localStorage.getItem('source') } });
                            }
                        });
                    })
                    .catch((err) => {});
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        }
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    }
};
</script>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
    /* background-color: #fe6114; */
}

.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
}

.header .logo {
    float: left;

    line-height: 70px;
}

.header .logo > span {
    font-size: 16px;
    font-weight: 500;
}

.header-right {
    float: right;
}

.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}

.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}

.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}

.btn-bell .el-icon-bell {
    color: #fff;
}

.user-name {
    margin-left: 10px;
}
.legwork-box {
    height: 100%;
    margin-left: 20px;
}
.scheduling-dispatch {
    height: 100%;
}

.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}

.el-dropdown-menu__item {
    text-align: center;
}

.public-screen {
    font-size: 16px;
    margin-right: 10px;
    color: #fff;
    cursor: pointer;
}

.public-screen i {
    font-size: 20px;
}

.add-order {
    width: 200px;
    height: 100%;
    border-radius: 0;
    margin-left: 10px;
}
</style>
